import React from "react";
import { Button } from "../ui/button";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from "../ui/dialog";

import { i18n } from "../../translate/i18n";

// `confirmLabel` deixa o botão dizer a ação ("Excluir cargo") em vez de "Ok".
// Num diálogo que apaga coisa, "Ok" não informa nada a quem está inseguro —
// e é justamente aí que a pessoa precisa saber o que vai acontecer.
const ConfirmationModal = ({
	title,
	children,
	open,
	onClose,
	onConfirm,
	confirmLabel,
}) => {
	return (
		<Dialog open={open} onOpenChange={() => onClose(false)}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<p className="text-sm text-muted-foreground">{children}</p>
				<DialogFooter>
					<Button variant="outline" onClick={() => onClose(false)}>
						{i18n.t("confirmationModal.buttons.cancel")}
					</Button>
					<Button
						variant="destructive"
						onClick={() => {
							onClose(false);
							onConfirm();
						}}
					>
						{confirmLabel || i18n.t("confirmationModal.buttons.confirm")}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default ConfirmationModal;
